function total(dim, alt) {
  let count = 0;
  count += dim?.times_cited ? 1 : 0;
  count += dim?.recent_citations ? 1 : 0;
  count += dim?.relative_citation_ratio ? 1 : 0;
  count += dim?.field_citation_ratio ? 1 : 0;
  count += alt?.score ? 1 : 0;
  return count;
}

function metrics({ doi, syncApi }) {
  if (metrics.result) {
    return metrics.result;
  }
  return metrics.result = Promise.all([
    syncApi.metrics.dimensions({ doi }).catch(() => null),
    syncApi.metrics.altmetric({ doi }).catch(() => null)
  ]).then(([dim, alt]) => {
    return {
      dimensions: dim,
      altmetric: alt,
      count: total(dim, alt)
    }
  });
}

module.exports = metrics;
